import React, { Component } from 'react';
import { connect } from 'react-redux';

// screens
import Dashboard from './screens/Dashboard';
import ScheduleConsult from './containers/ScheduleConsult';
import Appointments from './screens/Appointments';
import Results from './screens/Results';
import MyJourney from './screens/MyJourney';
import Messages from './screens/Messages';
import Billing from './screens/Billing';
import Documents from './screens/Documents';
import Settings from './screens/Settings';
import Login from './containers/Login';

// Layouts
import Main from './layouts/Main';
import Form from './layouts/Form';

// Protected Route component will check if user is logged in before rendering component
const ProtectedRoute = (WrappedComponent) => {
  class AuthenticatedComponent extends Component {
    constructor(props) {
      super(props);
      this.checkAuth();
    }

    checkAuth = async () => {
      if (!this.props.isAuthenticated) {
        this.props.history.replace('/login');
      }
    }

    render () {
      return this.props.isAuthenticated ? <WrappedComponent {...this.props} /> : null;
    }
  }

  const mapStateToProps = (state) => ({
    isAuthenticated: state.user.data !== null
  });

  return connect(mapStateToProps)(AuthenticatedComponent);
}

export default [
  {
    path: '/',
    component: ProtectedRoute(Dashboard),
    layout: Main
  },
  {
    path: '/create-account',
    component: ScheduleConsult,
    layout: Form
  },
  {
    path: '/appointments',
    component: ProtectedRoute(Appointments),
    layout: Main
  },
  {
    path: '/results',
    component: ProtectedRoute(Results),
    layout: Main
  },
  {
    path: '/myjourney',
    component: ProtectedRoute(MyJourney),
    layout: Main
  },
  {
    path: '/messages',
    component: ProtectedRoute(Messages),
    layout: Main
  },
  {
    path: '/billing',
    component: ProtectedRoute(Billing),
    layout: Main
  },
  {
    path: '/documents',
    component: ProtectedRoute(Documents),
    layout: Main
  },
  {
    path: '/settings',
    component: ProtectedRoute(Settings),
    layout: Main
  },
  {
    path: '/login',
    component: Login,
    layout: Form
  }
];




// WEBPACK FOOTER //
// ./src/Routes.js